export default function validateRedirectURL(redirectTo) {
  return redirectTo?.startsWith('/') &&
    !redirectTo?.includes('/\\') &&
    !redirectTo?.startsWith('//') &&
    !/^\/[\s]{1}/.test(redirectTo)
    ? redirectTo
    : false;
}
